// utils/translations.js
const translations = {
    fr: {
        contactUsTitle: "Contactez-nous",
        contactUsText: "Si vous rencontrez des difficultés, n'hésitez pas à ",
        contactUsLink: "nous contacter",
        helpText: "Nous nous ferons un plaisir de vous aider !",
        lastNameLabel: "Nom :",
        firstNameLabel: "Prénom :",
        emailLabel: "Email :",
        issueTypeLabel: "Nature du problème :",
        selectPlaceholder: "Sélectionner...",
        technicalIssue: "Problème technique",
        usageQuestion: "Question sur l'utilisation",
        otherIssue: "Autre",
        messageLabel: "Message :",
        sendButton: "Envoyer",
        messageSentSuccess: "Votre message a bien été envoyé.",
        messageSendFailure: "Échec de l'envoi du message.",
        genericError: "Une erreur est survenue. Veuillez réessayer plus tard."
    },
    en: {
        contactUsTitle: "Contact Us",
        contactUsText: "If you encounter difficulties, do not hesitate to ",
        contactUsLink: "contact us",
        helpText: "We will be happy to help you!",
        lastNameLabel: "Last Name:",
        firstNameLabel: "First Name:",
        emailLabel: "Email:",
        issueTypeLabel: "Nature of the issue:",
        selectPlaceholder: "Select...",
        technicalIssue: "Technical issue",
        usageQuestion: "Usage question",
        otherIssue: "Other",
        messageLabel: "Message:",
        sendButton: "Send",
        messageSentSuccess: "Your message has been sent successfully.",
        messageSendFailure: "Failed to send the message.",
        genericError: "An error occurred. Please try again later."
    },
    de: {
        contactUsTitle: "Kontaktieren Sie uns",
        contactUsText: "Wenn Sie Schwierigkeiten haben, zögern Sie nicht, ",
        contactUsLink: "uns zu kontaktieren",
        helpText: "Wir helfen Ihnen gerne!",
        lastNameLabel: "Nachname:",
        firstNameLabel: "Vorname:",
        emailLabel: "E-Mail:",
        issueTypeLabel: "Art des Problems:",
        selectPlaceholder: "Auswählen...",
        technicalIssue: "Technisches Problem",
        usageQuestion: "Frage zur Nutzung",
        otherIssue: "Sonstiges",
        messageLabel: "Nachricht:",
        sendButton: "Senden",
        messageSentSuccess: "Ihre Nachricht wurde erfolgreich gesendet.",
        messageSendFailure: "Fehler beim Senden der Nachricht.",
        genericError: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal."
    },
    es: {
        contactUsTitle: "Contáctanos",
        contactUsText: "Si tiene dificultades, no dude en ",
        contactUsLink: "contactarnos",
        helpText: "¡Estaremos encantados de ayudarle!",
        lastNameLabel: "Apellido:",
        firstNameLabel: "Nombre:",
        emailLabel: "Correo electrónico:",
        issueTypeLabel: "Tipo de problema:",
        selectPlaceholder: "Seleccionar...",
        technicalIssue: "Problema técnico",
        usageQuestion: "Pregunta sobre el uso",
        otherIssue: "Otro",
        messageLabel: "Mensaje:",
        sendButton: "Enviar",
        messageSentSuccess: "Su mensaje ha sido enviado con éxito.",
        messageSendFailure: "Error al enviar el mensaje.",
        genericError: "Se ha producido un error. Por favor, inténtelo de nuevo más tarde."
    },
    it: {
        contactUsTitle: "Contattaci",
        contactUsText: "Se hai difficoltà, non esitare a ",
        contactUsLink: "contattarci",
        helpText: "Saremo felici di aiutarti!",
        lastNameLabel: "Cognome:",
        firstNameLabel: "Nome:",
        emailLabel: "Email:",
        issueTypeLabel: "Tipo di problema:",
        selectPlaceholder: "Seleziona...",
        technicalIssue: "Problema tecnico",
        usageQuestion: "Domanda sull'uso",
        otherIssue: "Altro",
        messageLabel: "Messaggio:",
        sendButton: "Invia",
        messageSentSuccess: "Il tuo messaggio è stato inviato con successo.",
        messageSendFailure: "Invio del messaggio fallito.",
        genericError: "Si è verificato un errore. Per favore riprova più tardi."
    }
};

export default translations;
